import React from 'react'

function Service6() {
    return (
        <div>
            <h1>Jai Maharashtra</h1>
        </div>
    )
}

export default Service6
